import { createSelector } from 'reselect';
import { IReduxState } from '../../../types';

export const getRequestUrlSelector = createSelector(
  (state: IReduxState) => state.appJson,
  (appJson) => appJson.requestEndpoint,
);
